import type { LeasingInventoryState, LeasingUnitDTO } from '#types/types';

const sanitizeLabel = (value: string | null | undefined): string | null => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const getUnitDisplayName = (
  unit: LeasingUnitDTO | null | undefined,
  inventory: LeasingInventoryState
): string | null => {
  if (!unit) return null;

  const unitIdentifier = sanitizeLabel(unit.unitIdentifier);
  const unitName = sanitizeLabel(unit.name);
  
  // Résolution stricte via le registre de l'inventory
  const property = inventory.Property.registry[unit.propertyId];
  const propertyName = sanitizeLabel(property?.name);

  const unitLabel = unitIdentifier
    ? `Unit ${unitIdentifier}`
    : unitName;

  // Si on a le label de l'unité et le nom de la propriété, on combine
  if (unitLabel && propertyName) return `${unitLabel} (${propertyName})`;
  
  // Sinon on renvoie ce qu'on a (le label de l'unité ou le nom de la propriété)
  return unitLabel ?? propertyName ?? null;
};